
/**
 * 搭配ShowMsgModal.vue中的modal
 * 將欲顯示的字串及style作為參數傳進函數中，最後自動顯示
 */
function showModal(text = "", style = {}) {
    let textEle = document.querySelector("#showMsgModalText");

    // 清除
    textEle.removeAttribute("style");
    textEle.innerHTML = "";

    // 設定要顯示的字串&style
    textEle.innerHTML = text;
    if (typeof (style) == "object" && Object.keys(style).length > 0) {
        for (let attr in style) {
            textEle.style[attr] = style[attr];
        }
    }

    // 顯示modal
    document.querySelector("#showMsgModalHyperlink").click();
}



export default { showModal }